"use client";

import { useLocale } from "next-intl";
import { useState } from "react";
import HelpCategories from "./HelpCategories";
import HelpFAQ from "./HelpFAQ";
import HelpHero from "./HelpHero";
import HelpSupport from "./HelpSupport";

export default function HelpClient() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const [search, setSearch] = useState("");

  return (
    <div className="najdi bg-background text-ink-900" dir={isAr ? "rtl" : "ltr"}>
      <HelpHero isAr={isAr} search={search} onSearch={setSearch} />
      <HelpCategories isAr={isAr} query={search} />
      <HelpFAQ isAr={isAr} query={search} />
      <HelpSupport isAr={isAr} />
    </div>
  );
}
